// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3mHnT","overflowing":"ReadFullNote_overflowing__2i0IM"};